<template>
  <div>
    <SearchForm @submit="submit($event)" />

    <SearchResults v-if="formData.terms" v-bind="formData" />
  </div>
</template>

<script>
import * as R from 'ramda'
import SearchForm from './SearchForm.vue'
import SearchResults from './SearchResults.vue'

export default {
  name: 'SearchPanel',

  data() {
    return {
      formData: {},
    }
  },

  methods: {
    submit(formData) {
      this.formData = {...formData}

      // If the user clears the search, and the current URL includes
      // ?highlightText, then clear it so that highlighting goes away.
      // The Reader component notices this special change and avoids closing the
      // panel on the route change.
      const path = ['query', 'highlightText']
      if (!formData.terms && R.path(path, this.$route)) {
        this.$router.push(R.dissocPath(path, this.$route))
      }
    },
  },

  components: {
    SearchForm,
    SearchResults,
  },
}
</script>
